<template>
    <div class="message-subject">
        <h2>{{message.subject}}</h2>
        <div class="actions">
            <ActionButton v-if="orientation_start !== 'top'"
                v-tooltip='"messages.actions.expand"'
                icon='fas fa-expand-alt'
                class='clear expand'
                @click="onToggleOrientation()"
            />
            <ActionButton
                v-tooltip='"messages.actions.popup"'
                icon='fas fa-external-link-alt'
                class='clear'
                @click="onOpenInPopup()"
            />
        </div>
    </div>
</template>

<script setup>
  import {defineProps, defineEmits} from 'vue';
  import {onUnmounted}              from 'vue';
  import ActionButton               from '@/vue/Elements/Buttons/ActionButton.vue';
  import LayoutSettingsController   from '@/js/Webmail/LayoutSettingsController';
  import PopupController            from '@/js/Webmail/PopupController';

  const props = defineProps({
    message  : {},
    folder_id: {},
  })

  const emit = defineEmits([
    'openMessagePopup',
  ]);

  const orientation_start = LayoutSettingsController.theme_orientation;
  let   changed           = false;

  onUnmounted(() => {
    if (changed === true) {
      LayoutSettingsController.theme_orientation = orientation_start;
    }
  })

  const onToggleOrientation = () => {
    LayoutSettingsController.theme_orientation = (LayoutSettingsController.theme_orientation === 'top') ? orientation_start : 'top';
    changed = true;
  }

  const onOpenInPopup = () => {
    emit('openMessagePopup');
  }

</script>
